import React from 'react';
import { reduxWrapper } from '@common/redux/store';
import { loadEvent } from '@common/redux/slices/event.slice';
import {
  loadRecommendationsForEventEvents,
  loadRecommendationsForEventPlaces,
} from '@common/redux/slices/recommendation.slice';
import { SingleEvent } from '@kursk/components/pages/SingleEvent/SingleEvent';
import { NotFoundPage } from '@kursk/components/pages/404/NotFoundPage';
import { loadFeedbacks } from "@common/redux/slices/feedbacks.slice";

export default function Event({ notFound }) {

  if (notFound) {
    return (<NotFoundPage/>);
  }
  return (
    <SingleEvent />
  );
}

export const getServerSideProps = reduxWrapper.getServerSideProps(async ({ store, params }) => {
  const { id } = params;
  await Promise.all([
    store.dispatch<any>(loadEvent({ _id: id })),
    store.dispatch<any>(loadRecommendationsForEventEvents({ _id: id })),
    store.dispatch<any>(loadRecommendationsForEventPlaces({ _id: id })),
    store.dispatch<any>(loadFeedbacks({ type: 'event', eventId: Number(id) })),
  ]);
  const { event } = store.getState().eventSlice;

  if (!event?._id) {
    return {
      props: { notFound: true }
    };
  }
});
